import { computed } from 'vue'
import { useSessionStorage } from '@vueuse/core'

const LOGIN_ATTEMPTS_KEY = 'login_attempts_count'
const SHOW_CLEAR_CACHE_THRESHOLD = 3

/**
 * Composable to track login attempts and determine when to show clear cache option
 */
export function useLoginAttempts() {
  const attemptCount = useSessionStorage<number>(LOGIN_ATTEMPTS_KEY, 0)

  function incrementLoginAttempts() {
    attemptCount.value += 1
  }

  function resetLoginAttempts() {
    attemptCount.value = 0
  }

  const shouldShowClearCacheAlert = computed(() => {
    return attemptCount.value >= SHOW_CLEAR_CACHE_THRESHOLD
  })

  return {
    attemptCount,
    incrementLoginAttempts,
    resetLoginAttempts,
    shouldShowClearCacheAlert,
  }
}
